import { LoruleRequestConfig } from '@galaxy/lorule-react-commons';
import { callWebUtils, commonHeaders } from './commonApiUtil';
import { ActionMemoSearch, ActionMemoItem } from './actionMemoListApiTypes';

const generateSearchQueryString = (search?: ActionMemoSearch | null) => {
    let queryString = '';
    if (search) {
        const {
            textSearchType,
            textSearchValues,
            amNumber,
            supNumber,
            amNumberFrom,
            amNumberTo,
            dateFrom,
            dateTo,
            creationDateFrom,
            creationDateTo,
            approvalDateFrom,
            approvalDateTo,
            budgetAmountFrom,
            budgetAmountTo,
            amStatuses,
            amCreator,
            projectManagerId,
            templateCodes,
            organizationIds,
            currentApproverId,
            contractSignerId,
            approvalOnly,
            watching,
            owner,
            tasks,
            expanded,
        } = search;
        if (textSearchType) {
            queryString += `&textSearchType=${textSearchType}`;
            if (textSearchValues && textSearchValues.length > 0) {
                queryString += textSearchValues.reduce(
                    (previousValue, currentValue) => `${previousValue}&textSearch=${currentValue}`,
                    '',
                );
            }
        }
        if (amNumber) {
            queryString += `&amNumber=${amNumber}`;
            if (supNumber) queryString += `&supNumber=${supNumber}`;
        }
        if (amNumberFrom) queryString += `&amNumberFrom=${amNumberFrom}`;
        if (amNumberTo) queryString += `&amNumberTo=${amNumberTo}`;
        if (dateFrom) queryString += `&dateFrom=${dateFrom}`;
        if (dateTo) queryString += `&dateTo=${dateTo}`;
        if (creationDateFrom) queryString += `&creationDateFrom=${creationDateFrom}`;
        if (creationDateTo) queryString += `&creationDateTo=${creationDateTo}`;
        if (approvalDateFrom) queryString += `&approvalDateFrom=${approvalDateFrom}`;
        if (approvalDateTo) queryString += `&approvalDateTo=${approvalDateTo}`;
        if (budgetAmountFrom) queryString += `&budgetAmountFrom=${budgetAmountFrom}`;
        if (budgetAmountTo) queryString += `&budgetAmountTo=${budgetAmountTo}`;
        if (budgetAmountFrom) queryString += `&budgetAmountFrom=${budgetAmountFrom}`;
        if (amStatuses && amStatuses.length > 0) {
            queryString += amStatuses.reduce(
                (previousValue, currentValue) => `${previousValue}&amStatus=${currentValue}`,
                '',
            );
        }
        if (amCreator) queryString += `&amCreator=${amCreator}`;
        if (projectManagerId) queryString += `&projectManagerId=${projectManagerId}`;
        if (templateCodes && templateCodes.length > 0) {
            queryString += templateCodes.reduce(
                (previousValue, currentValue) => `${previousValue}&template=${currentValue}`,
                '',
            );
        }
        if (organizationIds && organizationIds.length > 0) {
            queryString += organizationIds.reduce(
                (previousValue, currentValue) => `${previousValue}&organization=${currentValue}`,
                '',
            );
        }
        if (currentApproverId) queryString += `&currentApproverId=${currentApproverId}`;
        if (contractSignerId) queryString += `&contractSignerId=${contractSignerId}`;
        if (approvalOnly !== null && approvalOnly !== undefined)
            queryString += `&approvalOnly=${approvalOnly}`;
        if (watching !== null && watching !== undefined) queryString += `&watching=${watching}`;
        if (owner !== null && owner !== undefined) queryString += `&owner=${owner}`;
        if (tasks !== null && tasks !== undefined) queryString += `&tasks=${tasks}`;
        if (expanded !== null && expanded !== undefined) queryString += `&expanded=${expanded}`;
    }
    return queryString;
};

export const getActionMemos = async (
    config: LoruleRequestConfig,
    search?: ActionMemoSearch | null,
    pageSize?: number | null,
    pageIndex?: number | null,
    sortBy?: string | null,
    desc?: boolean | null,
    user: boolean = true,
) => {
    let queryString = generateSearchQueryString(search);
    if (sortBy) queryString += `&sortBy=${sortBy}`;
    if (desc !== null && desc !== undefined) queryString += `&desc=${desc}`;
    if (pageIndex) queryString += `&pageIndex=${pageIndex}`;
    if (pageSize) queryString += `&pageSize=${pageSize}`;
    return callWebUtils<Array<ActionMemoItem>>(
        config,
        `/actionmemo?user=${user}${queryString}`,
        'GET',
        null,
        commonHeaders,
    );
};

export const getActionMemoCount = async (
    config: LoruleRequestConfig,
    search?: ActionMemoSearch | null,
    user: boolean = true,
) => {
    const queryString = generateSearchQueryString(search);
    return callWebUtils<number>(
        config,
        `/actionmemo?count=true&user=${user}${queryString}`,
        'GET',
        null,
        commonHeaders,
    );
};
